import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * FOUND-09 — runtime Zod validation of Vite-injected env.
 *
 * Module-load side effect: createEnv() throws on any validation failure BEFORE
 * React mounts, so a misconfigured VITE_API_BASE_URL is caught at boot instead
 * of surfacing as an opaque network error later.
 *
 * Deliberately shorter than the other three apps': the global login has no
 * tenant (that is the entire point — no `VITE_DEV_TENANT_SLUG` here, and no
 * way for one to leak in), no MSW and no assistant.
 */
export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_API_BASE_URL: z.string().url(),
    VITE_SENTRY_DSN: z.string().optional(),
    // Google sign-in web client id. Absent → no "Continue with Google" button.
    VITE_GOOGLE_CLIENT_ID: z.string().optional(),
    // Microsoft (Entra) application id. Absent → no "Sign in with Microsoft" button.
    VITE_MICROSOFT_CLIENT_ID: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
